import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
import uploadData from "../services/uploadData";

const handleFetchUnits = async ({ page = "", limit = "", params }: any) => {
  const uri = `v1/units?page=${page}&limit=${limit}&${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleExportUnits = async () => {
  const uri = `v1/units/export`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateUnit = async ({ data }: any) => {
  const uri = `v1/units`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateUnit = async ({ _id, data }: any) => {
  const uri = `v1/units/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleAssignApprover = async ({ _id, data }: any) => {
  const uri = `v1/units/${_id}/approver`;
  const response = patchData({ data, uri });
  return response;
};

const handleUploadUnits = async ({ data }: any) => {
  const uri = `v1/units/upload`;
  const response = uploadData({ data, uri });
  return response;
};

const handleDeleteUnit = async ({ data, _id }: any) => {
  const uri = `v1/units/${_id}`;
  const response = deleteData({ data, uri });
  return response;
};

export {
  handleFetchUnits,
  handleExportUnits,
  handleCreateUnit,
  handleUpdateUnit,
  handleDeleteUnit,
  handleUploadUnits,
  handleAssignApprover
};
